var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGolf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.5px",
    height: "16.00375px",
    viewBox: "0 0 9.5 16.00375",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Small/Golf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotelcard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ThemaBadge/Round/Golf",
    transform: "translate(-11.500000, -8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small/Golf",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(0.000000, 0.003750)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13,8.10375 C13,6.95375 12.05,6.00375 10.9,6.00375 L10.5,6.00375 L10.5,5.00375 L5.5,5.00375 L5.5,6.35375 L4,7.25375 C3.7,7.45375 3.5,7.75375 3.5,8.10375 L3.5,12.00375 C3.5,12.35375 3.7,12.70375 4,12.85375 L5.5,13.75375 L5.5,14.50375 C5.5,15.35375 6.15,16.00375 7,16.00375 L9,16.00375 C9.85,16.00375 10.5,15.35375 10.5,14.50375 L10.5,13.75375 C11.65,12.45375 13,10.45375 13,8.10375 Z M10.9,7.00375 C11.5,7.00375 12,7.50375 12,8.10375 C12,9.65375 11.3,11.05375 10.5,12.15375 L10.5,7.00375 L10.9,7.00375 Z M5.1,2.80375 L6.6,3.20375 L6.6,4.00375 L7.5,4.00375 L7.5,3.05375 C7.5,2.70375 7.35,2.35375 7.05,2.15375 L6.1,1.50375 C5.8,1.30375 5.35,1.35375 5.15,1.65375 L4.85,2.10375 C4.65,2.35375 4.8,2.75375 5.1,2.80375 Z M9.4,2.85375 L10.95,1.80375 C11.35,1.50375 11.5,0.90375 11.2,0.45375 C10.85,-0.09625 10.1,-0.14625 9.7,0.30375 L8.85,1.15375 C8.65,1.35375 8.5,1.65375 8.5,1.95375 L8.5,4.00375 L9.4,4.00375 L9.4,2.85375 Z",
    id: "Combined-Shape",
    fill: "#2800A0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/Golf.aee59ddd32c8c4cfdcbcbe110797d5a9.svg";
export { ForwardRef as ReactComponent };